import { AdvanceFilter } from 'components/analytics/customer/AdvanceFilter'
import { useEffect, useState } from 'react'
import { useFetch } from 'services/useFetch'
import { INITIAL_ADVANCE_FILTER } from 'configs/analytics/configTableCustomer'
import { constructOptionsSelect } from 'utils/utils'
import { API_CUSTOMER } from 'services/apiAnalyticCustomer'

export const AdvanceFilterContainer = ({ show, setShow, values, onSubmit }) => {
    const [filterDetail, setFilterDetail] = useState({})
    const { fetching: getCities } = useFetch(API_CUSTOMER.CITIES)
    const [optionsCity, setOptionsCity] = useState([])

    const getFilterCount = () => {
        let count = 0
        Object.keys(values).map((i) => (count += values[i]?.length))
        return count
    }

    const onClear = () => {
        setFilterDetail(INITIAL_ADVANCE_FILTER)
    }

    const onSearchCity = (value = '') => {
        getCities({ search: value }).then((response) => {
            const newOption = constructOptionsSelect(response?.data, 'name', 'name')
            setOptionsCity(newOption)
        })
    }

    const onChangeForm = (e) => {
        const { name, value } = e
        setFilterDetail({ ...filterDetail, [name]: value })
    }

    useEffect(() => {
        if (show) onSearchCity()
        setFilterDetail(values)
    }, [show, values])

    const props = {
        show,
        setShow,
        filterDetail,
        getFilterCount,
        onChangeForm,
        onClear,
        onSearchCity,
        optionsCity,
        onSubmit,
    }

    return <AdvanceFilter {...props} />
}
